module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latestNews"
  }, [_c('div', {
    staticClass: "latestNews__heading"
  }, [_vm._v("\n    latest news\n  ")]), _c('div', {
    staticClass: "latestNews__content"
  }, _vm._l((_vm.latestNews), function(news, index) {
    return _c('div', {
      key: index,
      staticClass: "article"
    }, [_c('div', {
      staticClass: "article__sectionLable"
    }, [_c('amp-label', {
      attrs: {
        "node": news,
        "mode": "latestNews"
      }
    })], 1), (_vm.newsUrl) ? _c('a', {
      attrs: {
        "href": _vm.newsUrl(news)
      }
    }, [_c('div', {
      staticClass: "article__title"
    }, [_vm._v(_vm._s(_vm.title(news)))]), _c('div', {
      staticClass: "article__image"
    }, [_c('amp-img', {
      attrs: {
        "src": _vm.thumbnail(news),
        "width": "400",
        "layout": "responsive",
        "height": "300"
      }
    })], 1)]) : _vm._e()])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d73edd46","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpLatestNews.vue
// module id = 1788
// module chunks = 29